export default {
  data() {
    return {
      emailRules: [
        (v) => !!v || 'El correo es obligatorio',
        (v) => /.+@.+\..+/.test(v) || 'Ingrese un correo válido',
      ],
    };
  },
};
